/** CRM menu labels → Spatie permission names (must match backend RestrictsCrmAccess). */
export const CRM_MENU_PERMISSIONS = {
  Contacts: "Contact.Read",
  Clients: "Client.Read",
  Deals: "Deal.Read",
  Leads: "Lead.Read",
  Pipeline: "Pipeline.Read",
  Analytics: "Analytics.Read",
  Activities: "Activity.Read",
};

/** Route patterns for CRM pages → permission + plan module key. */
export const CRM_ROUTE_RULES = [
  {
    permission: "Contact.Read",
    moduleKey: "crm_contacts",
    matches: (path) =>
      path === "/crm/contacts" ||
      path === "/crm/contacts-grid" ||
      path.startsWith("/crm/contacts-details/"),
  },
  {
    permission: "Client.Read",
    moduleKey: "crm_clients",
    matches: (path) =>
      path === "/crm/clients" ||
      path === "/crm/clients-grid" ||
      path.startsWith("/crm/clients-details/"),
  },
  {
    permission: "Deal.Read",
    moduleKey: "crm_deals",
    matches: (path) =>
      path === "/crm/deals-list" ||
      path === "/crm/deals-grid" ||
      path.startsWith("/crm/deals-details/"),
  },
  {
    permission: "Lead.Read",
    moduleKey: "crm_leads",
    matches: (path) =>
      path === "/crm/leads-list" ||
      path === "/crm/leads-grid" ||
      path.startsWith("/crm/leads-details/"),
  },
  {
    permission: "Pipeline.Read",
    moduleKey: "crm_pipeline",
    matches: (path) =>
      path === "/crm/pipeline" || path === "/crm/pipeline-list",
  },
  {
    permission: "Analytics.Read",
    moduleKey: "crm_analytics",
    matches: (path) =>
      path === "/crm/analytics" || path === "/crm/analytics-list",
  },
  {
    permission: "Activity.Read",
    moduleKey: "crm_activities",
    matches: (path) =>
      path === "/crm/activity" || path === "/crm/activity-list",
  },
];

/** Preferred CRM landing pages when visiting `/crm` (module, path, permission). */
export const CRM_LANDING_ORDER = [
  ["crm_contacts", "/crm/contacts", "Contact.Read"],
  ["crm_clients", "/crm/clients", "Client.Read"],
  ["crm_deals", "/crm/deals-grid", "Deal.Read"],
  ["crm_leads", "/crm/leads-grid", "Lead.Read"],
  ["crm_pipeline", "/crm/pipeline", "Pipeline.Read"],
  ["crm_analytics", "/crm/analytics", "Analytics.Read"],
  ["crm_activities", "/crm/activity", "Activity.Read"],
];

export function isCrmMenuValue(menuValue) {
  return Object.prototype.hasOwnProperty.call(CRM_MENU_PERMISSIONS, menuValue);
}

export function crmPermissionForMenu(menuValue) {
  return CRM_MENU_PERMISSIONS[menuValue] || null;
}

export function matchCrmRoute(path) {
  if (!path || !path.startsWith("/crm")) return null;
  return CRM_ROUTE_RULES.find((rule) => rule.matches(path)) || null;
}

export function resolveCrmLanding(
  modules,
  hasPermission,
  { fullAccess = false, requirePermission = false } = {},
) {
  if (fullAccess) {
    return "/crm/deals-grid";
  }

  const allowedModules = Array.isArray(modules) ? modules : [];
  const landing = CRM_LANDING_ORDER.find(([moduleKey, , permission]) => {
    if (!allowedModules.includes(moduleKey)) return false;
    if (requirePermission) return hasPermission(permission);
    return true;
  });

  return landing ? landing[1] : null;
}

export function canShowCrmMenuForEmployee(menuValue, hasPermission) {
  const permission = crmPermissionForMenu(menuValue);
  if (!permission) return false;
  return hasPermission(permission);
}

export function canAccessCrmRoute(path, hasPermission) {
  const rule = matchCrmRoute(path);
  if (!rule) return false;
  return hasPermission(rule.permission);
}
